import { OwnedAssistanceProduct } from '@/interfaces';
import {
  RSA_RACQ_EVERYDAY_LITE,
  RSA_RACQ_EVERYDAY,
  RSA_RACQ_EVERYDAY_PLUS,
  RSA_RACQ_ULTRA_CARE,
  RoadsideProductType,
  RSA_ROADSIDE_EXCESS_USE,
} from '../roadside-helpers';

const showBanner = (policy: OwnedAssistanceProduct): boolean => {
  return (
    !!policy?.tierId &&
    policy.roadsidePolicyType === RoadsideProductType.Standard &&
    [RSA_RACQ_EVERYDAY_LITE, RSA_RACQ_EVERYDAY, RSA_RACQ_EVERYDAY_PLUS, RSA_RACQ_ULTRA_CARE].includes(policy.tierId)
  );
};

const showBannerExcess = (policy: OwnedAssistanceProduct): boolean => {
  return policy.productCode === RSA_ROADSIDE_EXCESS_USE;
};

export const RSASubcontentRules = {
  showBanner,
  showBannerExcess,
};
